<div class="topbar-item nav-user">
    <div ngbDropdown [placement]="'bottom-end'" class="dropdown">
        <button ngbDropdownToggle class="btn btn-link p-0 topbar-link dropdown-toggle drop-arrow-none px-2">
            <span class="avatar avatar-sm me-lg-2 d-flex">
                <span class="avatar-title bg-primary-subtle text-primary rounded-circle">
                    <ng-icon name="tablerUser" class="fs-18"></ng-icon>
                </span>
            </span>
            <div class="d-lg-flex align-items-center gap-1 d-none">
                <h5 class="my-0">{{ displayName }}</h5>
                <span class="d-flex align-middle"><ng-icon name="tablerChevronDown"/></span>
            </div>
        </button>
        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
            @for (item of menuItems; track i; let i = $index) {
                <div>
                    @if (item.isHeader) {
                        <div class="dropdown-header noti-title">
                            <h6 class="text-overflow m-0">{{ item.label }}</h6>
                        </div>
                    }
                    @if (item.isDivider) {
                        <div class="dropdown-divider"></div>
                    }

                    @if (!item.isHeader && !item.isDivider) {
                    @if (item.label === 'Log Out') {
                        <button type="button" class="dropdown-item" [class]="item.class" (click)="logout()">
                            <ng-icon [name]="item.icon" size="17"
                                     class="align-middle d-inline-flex align-items-center me-2"/>
                            <span class="align-middle" [innerHTML]="item.label"></span>
                        </button>
                    }
                    @if (item.label !== 'Log Out') {
                        <a [routerLink]="item.url"
                           class="dropdown-item"
                           [class]="item.class">
                            <ng-icon [name]="item.icon" size="17"
                                     class="align-middle d-inline-flex align-items-center me-2"/>
                            <span class="align-middle" [innerHTML]="item.label"></span>
                        </a>
                    }
                    }
                </div>
            }
        </div>
    </div>
</div>
